export default __webpack_public_path__ + "static/media/Cutting Edge Technology Desaturation.311252f1.png";